import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import './i18n/config';
import axios from 'axios';

// Every API call carries the session token. Several components call axios
// directly without headers; the backend now rejects unauthenticated data
// and audit requests, so attach it centrally for our own API only.
const API_HOSTS = ['securegatecard.nordicbyte.co.uk', 'panel.securegatecard.nordicbyte.co.uk', window.location.host];
axios.interceptors.request.use((config) => {
  try {
    // Instances created with axios.create() carry a baseURL ('/api'); the
    // request url alone is relative to it, so join them before checking.
    const raw = (config.url || '').match(/^https?:/) ? config.url : (config.baseURL || '') + (config.url || '');
    const url = new URL(raw, window.location.origin);
    const isApi = url.pathname.startsWith('/api/') && API_HOSTS.includes(url.host);
    const token = localStorage.getItem('authToken');
    if (isApi && token && !config.headers?.Authorization) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
  } catch (_) { /* relative/odd URL: leave untouched */ }
  return config;
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// Register Service Worker for PWA. Auto-reload on activation of a new SW so
// users running stale builds (which previously caused OOM via the chunked
// credentials cache) pick up the fix without manual hard-refresh.
if ('serviceWorker' in navigator) {
  let reloadingForSW = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (reloadingForSW) return;
    reloadingForSW = true;
    window.location.reload();
  });

  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then((registration) => {
        console.log('[PWA] Service Worker registered:', registration.scope);

        setInterval(() => { registration.update(); }, 60 * 60 * 1000);

        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (newWorker) {
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                console.log('[PWA] New version installed — activating now');
                newWorker.postMessage({ type: 'SKIP_WAITING' });
              }
            });
          }
        });
      })
      .catch((error) => {
        console.warn('[PWA] Service Worker registration failed:', error);
      });
  });
}
